import * as yup from 'yup';

export const commonTariffCoaMappingValidation: { [x: string]: any; } = {
    tariffType: yup.string().required("Missing."),
    tariffCode: yup.string().required("Missing."),
    raType: yup.string().required("Missing."),
    revenueAccountCode: yup.string().required("Missing."),
    costCenterCode: yup.string().required("Missing."),
    productServiceCode: yup.string().required("Missing."),
    salesChannelCode: yup.string().required("Missing."),
    projectCode: yup.string().required("Missing."),
    spareCode: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createTariffCoaMappingValidation: { [x: string]: any; } = {
    ...commonTariffCoaMappingValidation,
};

export const createTariffCoaMappingValidationSchema = yup.object().shape(createTariffCoaMappingValidation);

